import { motion } from "framer-motion";

const CATEGORIES = [
  "All",
  // Consumer
  "Lifestyle", "Fashion", "Home", "Fitness", "Travel", "Beauty", "Food", "Pets",
  // Creator & Products
  "Hashtags", "Viral Formats", "Creator Trends", "Side Hustles",
  "TikTok Shop", "Amazon Trending", "Digital Products", "Gadgets",
  // B2B & Professional
  "Enterprise AI", "Low-Code/VBA Automation", "Workplace Efficiency",
  "Business Intelligence", "Developer Tools", "Cloud Infrastructure",
  "Sales & Marketing", "Cybersecurity"
];

const CategoryFilter = ({ selected, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {CATEGORIES.map((category) => (
        <motion.button
          key={category}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onSelect(category)}
          data-testid={`category-${category.toLowerCase()}`}
          className={`px-4 py-2.5 min-h-[44px] text-sm md:text-xs font-semibold rounded-full border-2 transition-all duration-150 ${
            selected === category 
              ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-purple-600 shadow-md" 
              : "bg-white text-gray-700 border-gray-300 hover:border-purple-400 hover:bg-gray-50"
          }`}
        >
          {category}
        </motion.button>
      ))}
    </div>
  );
};

export default CategoryFilter;
